import getApiBaseUrl from "../../utils/api";

const API_URL = getApiBaseUrl();

const userActions = ({ getStore, getActions, setStore }) => ({
  changePasswordFlagUpdated: () => {
    localStorage.setItem("must_change_password", "false");
    setStore({ mustChangePassword: false });
  },

  changePassword: async (currentPassword, newPassword, confirmPassword) => {
    try {
      const { token } = getStore();

      const response = await fetch(`${API_URL}/api/users/change-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          current_password: currentPassword,
          new_password: newPassword,
          confirm_new_password: confirmPassword,
        }),
      });

      const error = await getActions().handleApiError(response);
      if (error) return { success: false };

      const data = await response.json();

      if (!response.ok) {
        return { success: false, message: data.msg };
      }

      getActions().showToast("Contraseña actualizada", "success");
      getActions().changePasswordFlagUpdated();

      return { success: true };
    } catch (error) {
      console.error(error);
      getActions().showToast("Server error", "error");
      return { success: false };
    }
  },
});

export default userActions;
